import React, { Component } from 'react';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';
import {FormattedMessage} from "react-intl";

export class ValidationModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      validNumber:null,
      touched:false
    };
    this.validateNumber = this.validateNumber.bind(this);
    this.sendIsTicketGrupal = this.sendIsTicketGrupal.bind(this)
  }
  validateNumber(e){
	  // this.props.handleInputChange();
    const value = e.target.value;
    this.setState({
	    validNumber: value && !isNaN(value) && value<99,
      numTicketsToValidate: value
    });
  }

  sendIsTicketGrupal(){
    const {numTicketsToValidate, validNumber} = this.state;
    if(validNumber){
      this.props.handleIsTicketGrupal(true, numTicketsToValidate)
    }
  }

  render() {
    const {validNumber,touched} = this.state;
    return (
      <div>
        {this.props.ticketGroupValidation ? (
          <div>
            <Modal.Body>
              <div className="form-group">
                <label htmlFor="numTicketsToValidate">
	                <FormattedMessage defaultMessage="Selecciona el número de tiquets a validar" id="label.selest.number.tickets"/>
                </label>
                <input
                  autoFocus
                  className="form-control"
                  type="text"
                  placeholder="Número de tiquets"
                  name="numTicketsToValidate"
                  id="numTicketsToValidate"
                  onChange={(e) => this.validateNumber(e)}
                  onBlur={(e)=>this.setState({touched: true})}
                />
                {!validNumber && touched &&
                <span className="help-block error"><FormattedMessage id="error.helper.number" defaultMessage="Not a valid number"/></span>
                }
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button className={!validNumber ? 'disabled':''} onClick={this.sendIsTicketGrupal}>
	              <FormattedMessage defaultMessage="Ok" id="button.ok"/>
              </Button>
            </Modal.Footer>
          </div>
        ) : (
          <div>
            <Modal.Body>
              <label><FormattedMessage defaultMessage="¿Es un tiquet grupal?" id="message.modal.isgroup"/></label>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.props.handleIsTicketGrupal(true)}>
	              <FormattedMessage defaultMessage="Si" id="button.yes"/>
              </Button>
              <Button onClick={() => this.props.handleIsTicketGrupal(false)}>
	              <FormattedMessage defaultMessage="No" id="button.no"/>
              </Button>
            </Modal.Footer>
          </div>
        )}
      </div>
    );
  }
}
